module.exports = __webpack_public_path__ + "static/media/novair.bc79361f.svg";